module.exports = __webpack_public_path__ + "static/img/image.909e8ef0.png";